// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApplikasiKreditService = {};

ApplikasiKreditService.postGeneral = function (data) {
  return lossClient({
    url: `/ApkLoan/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.postGuarantor = function (data) {
  // console.log("🚀 ~ datapostGuarantor:", data);
  return lossClient({
    url: `/ApkLoan/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putGuarantor = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/ApkLoan/edit`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data.data,
  });
};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

ApplikasiKreditService.getGetApkLoanItem = function (prospectid) {
  const params = {
    pageSize: 20,
    pageIndex: 0,
    prospectid: prospectid?.code,
  };
  return lossClient({
    url: `/ApkLoan/getNAP?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getGetApkLoanItemCST = function (prospectid) {
  const params = {
    pageSize: 20,
    pageIndex: 0,
    prospectid: prospectid?.code,
  };
  return lossClient({
    url: `/ApkLoan/getCST?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getGetApkLoanItemCAS = function (prospectid) {
  const params = {
    pageSize: prospectid?.pageSize ?? 20,
    pageIndex: prospectid?.pageIndex ?? 0,
    prospectid: prospectid?.code,
    applicationid: prospectid?.applicationid,
    branchid: prospectid?.branchid,
    startApplicationDate: prospectid?.startApplicationDate,
    endApplicationDate: prospectid?.endApplicationDate,
    customername: prospectid?.customername,
    caid: prospectid?.caid,
  };
  return lossClient({
    url: `/ApkLoan/getCAS?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getApkLoanCreditScoring = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    applicationid: data?.applicationid,
    name: data?.name,
    endApplicationDate: data?.endApplicationDate,
    startApplicationDate: data?.startApplicationDate,
  };
  return lossClient({
    url: `/ApkLoan/ApkLoanCreditScoring?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getApkLoanSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    applicationid: data?.applicationid,
    name: data?.name,
    endApplicationDate: data?.endApplicationDate,
    startApplicationDate: data?.startApplicationDate,
  };
  return lossClient({
    url: `/ApkLoan/LoanSurvey?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getDetailSurvey = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/LoanSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.postLoanService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/LoanSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putLoanService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/LoanSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getEditApkLoanGuarantorService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    applicationId: data?.applicationId,
  };
  return lossClient({
    url: `/ApkLoanGuarantor/getEdit?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanGuarantorService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/ApkLoanGuarantor/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.getCharacterSurvey = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/CharacterSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanCharacterSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CharacterSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putApkLoanCharacterSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CharacterSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getConditionSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/ConditionSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanConditionSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/ConditionSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putApkLoanConditionSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/ConditionSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getCapitalSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/CapitalSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanCapitalSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CapitalSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putApkLoanCapitalSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CapitalSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getCapacitySurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/CapacitySurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanCapacitySurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CapacitySurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.putApkLoanCapacitySurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return fetch({
    url: `/CapacitySurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getCollateralSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/CollateralSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanCollateralSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CollateralSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.editApkLoanCollateralSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CollateralSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getCatatanSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/CatatanSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getCatatanSurveyDocService = function (data) {
  console.log("applicationId", data?.applicationid);

  return lossClient({
    url: `/CatatanSurvey/document?applicationid=${data?.applicationid}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addApkLoanCatatanSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CatatanSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.editApkLoanCatatanSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/CatatanSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.getKYCSurveyService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    code: data?.code,
  };
  return lossClient({
    url: `/KYCSurvey/search?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.getKYCSurveyDocumentService = function (data) {
  console.log("applicationId", data?.applicationid);

  return lossClient({
    url: `/KYCSurvey/kycdocument?applicationid=${data?.applicationid}`,
    method: "get",
    headers: {},
  });
};

ApplikasiKreditService.addKYCSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/KYCSurvey/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

ApplikasiKreditService.editKYCSurveyService = function (data) {
  // console.log("🚀 ~ dataputGuarantor:", data);
  return lossClient({
    url: `/KYCSurvey/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

ApplikasiKreditService.addTeleVerificationKKBService = function (data) {
  return lossClient({
    url: `/TeleVerificationKKB/add`,
    method: "post",
    data: data,
  });
};

ApplikasiKreditService.getTeleVerificationKKBAssessmentItemService = function (
  data
) {
  return lossClient({
    url: `/TeleVerificationKKB/getAssessmentItem`,
    method: "post",
    data: data,
  });
};

ApplikasiKreditService.addChecklistCreditAssessmentService = function (data) {
  return lossClient({
    url: `/ChecklistCreditAssessment/add`,
    method: "post",
    data: data,
  });
};

ApplikasiKreditService.ProceedChecklistCreditAssessmentService = function (data) {
  return lossClient({
    url: `/ChecklistCreditAssessment/Proceed`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

export default ApplikasiKreditService;
